module.exports = __webpack_public_path__ + "img/iphone1.705331a3.png";